import { useState } from "react";
import { Grid, Typography } from "@mui/material";
import GenericAlert from "../../components/GenericAlert";
import ExportFilters from "../../components/orders/ExportFilters";
import ExportOrdersTable from "../../components/tables/ExportOrdersTable";
import { IAlert } from "../../interfaces/alert";
import { IValidation } from "../../interfaces/form";
import {
  IExportOrdersValues,
  IExportOrdersErrors,
} from "../../interfaces/order";
import {
  ERROR,
  ERRORS_MESSAGES,
  ERROR_FROM_GREATER_THAN_TO,
  INFO,
  MEDIUM,
  POST,
} from "../../utils/constants";
import { fetchData } from "../../utils/dataProvider";
import { validateInputs } from "../../utils/inputValidations";
import Loader from "../../components/Loader";
import { useExportOrdersStrategy } from "../../customHooks/useExportOrders";

const { fromDateRequired, toDateRequired } = ERRORS_MESSAGES;

const formValidations: IValidation[] = [
  { id: "fromDate", type: "required", message: fromDateRequired },
  { id: "toDate", type: "required", message: toDateRequired },
  {
    id: "fromDate",
    type: "compare-dates",
    message: ERROR_FROM_GREATER_THAN_TO,
    param: "toDate",
  },
];

const ExportOrders = () => {
  const {
    strategy,
    carriers,
    merchants,
    aliases,
    requests,
    loading,
    alert,
    setAlert,
    refreshFiles,
    selectedMarketplace,
    currentUser,
    clients,
  } = useExportOrdersStrategy();

  const [values, setValues] = useState({} as IExportOrdersValues);
  const [errors, setErrors] = useState({} as IExportOrdersErrors);
  const [tableAlert, setTableAlert] = useState({} as IAlert);

  const handleSubmit = async () => {
    const inputErrors = validateInputs(values, formValidations);
    setErrors(inputErrors);

    if (Object.keys(inputErrors).length === 0) {
      setAlert({} as IAlert);
      setTableAlert({
        typeOfAlert: INFO,
        message: "El archivo se está procesando.",
        showAlert: true,
      });

      try {
        await fetchData({
          url: strategy.getSummaryEndpoint(),
          method: POST,
          body: strategy.buildSubmitBody(values, selectedMarketplace),
        });

        setValues({} as IExportOrdersValues);
        setTableAlert({} as IAlert);
        await refreshFiles();
      } catch (error: any) {
        setTableAlert({} as IAlert);
        setAlert({ typeOfAlert: ERROR, message: error, showAlert: true });
      }
    }
  };

  if (loading) return <Loader size={MEDIUM} />;

  return (
    <Grid container>
      <Grid
        item
        xs={12}
        md={7}
        display="flex"
        alignItems="center"
        justifyContent="start"
      >
        <Typography className="f-s-20 text-dark" ml={1}>
          Exportar órdenes
        </Typography>
      </Grid>

      <ExportFilters
        values={values}
        setValues={setValues}
        carriers={carriers}
        handleSubmit={handleSubmit}
        errors={errors}
        setErrors={setErrors}
        merchants={merchants}
        showstatusFilter={strategy.shouldFetchAliases()}
        aliases={aliases}
        clients={clients}
      />
      {alert.showAlert && (
        <Grid item xs={12} className="m-t-10">
          <GenericAlert alert={alert} />
        </Grid>
      )}

      {tableAlert.showAlert && (
        <Grid item xs={12} className="m-t-10">
          <GenericAlert alert={tableAlert} />
        </Grid>
      )}

      {requests.length > 0 && (
        <ExportOrdersTable requests={requests} entity={currentUser.entity} />
      )}
    </Grid>
  );
};

export default ExportOrders;
